import React from "react";
import { Paper } from "@mantine/core";
import CustomerForm from "../components/CustomerForm";
import { useNavigate } from "react-router-dom";
import StyledPageTitle from "../components/StyledPageTitle";

const CustomersCreatePage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <StyledPageTitle mb="sm">Create Customer</StyledPageTitle>
      <Paper>
        <CustomerForm onSubmit={(id) => navigate(`/app/customers/${id}`)} />
      </Paper>
    </>
  );
};

export default CustomersCreatePage;
